export default __webpack_public_path__ + "static/media/cfg-background-image.86c0b025.jpg";